import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { logError } from 'commons/logger';

// Module-level flag to ensure override only happens once
let hasOverridden = false;
const parsePostHogQuery = query => {
  try {
    const queryObject = JSON.parse(query);
    if (queryObject?.clear === true) {
      return false;
    }
    return queryObject;
  } catch (err) {
    logError(err, 'Unable to parse posthogOverrides query', {
      query
    });

    // clear overrides in for any malformed query
    return false;
  }
};
const usePostHogFeatureFlagWithPayload = name => {
  const $ = _c(6);
  const [value, setValue] = useState(null);
  const [payload, setPayload] = useState(null);
  let t0;
  let t1;
  if ($[0] !== name) {
    t0 = () => {
      const removePostHogEventListeners = [];
      const intervalId = setInterval(() => {
        if (!window.posthog) {
          return;
        }
        clearInterval(intervalId);
        const postHogOverrideQuery = new URLSearchParams(window.location.search).get("posthogOverrides");
        const removePostHogEventListener = window.posthog.onFeatureFlags(() => {
          if (!hasOverridden && postHogOverrideQuery && postHogOverrideQuery !== "" && postHogOverrideQuery !== "{}" && window.posthog.featureFlags) {
            hasOverridden = true;
            const parsedQuery = parsePostHogQuery(postHogOverrideQuery);
            if (parsedQuery !== false) {
              window.posthog.featureFlags.override(parsedQuery);
            }
          }
          if (window.posthog.isFeatureEnabled(name)) {
            const val = window.posthog.getFeatureFlag(name);
            const payloadValue = window.posthog.getFeatureFlagPayload(name);
            if (val !== null) {
              setValue(val);
              setPayload(payloadValue);
            }
          }
        });
        removePostHogEventListeners.push(removePostHogEventListener);
      }, 500);
      return () => {
        clearInterval(intervalId);
        removePostHogEventListeners.forEach(_temp);
      };
    };
    t1 = [name];
    $[0] = name;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== payload || $[4] !== value) {
    t2 = [value, payload];
    $[3] = payload;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default usePostHogFeatureFlagWithPayload;
function _temp(removePostHogEventListener_0) {
  removePostHogEventListener_0?.();
}